"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.buildTributeMockData = exports.TRIBUTE_MESSAGE_BODY = void 0;
const email_theme_tokens_1 = require("../../helpers/email-theme-tokens");
const icons_1 = require("../icons");
const locales_1 = require("../../internationalization/features/locales");
const email_templates_1 = require("../../internationalization/locales/email-templates");
exports.TRIBUTE_MESSAGE_BODY = "Thinking of you today, and grateful for everything you gave.<br />With love, the Smith family.";
const buildTributeMockData = ({ orgName, color, isDarkMode, isInMemory = false, firstName = "John", lastName = "Smith", inHonourName = "Jane Doe", message = exports.TRIBUTE_MESSAGE_BODY, locale = "en", }) => {
    const theme = (0, email_theme_tokens_1.resolveEmailThemeTokens)(color || "#FFFFFF", isDarkMode ? "dark" : "light");
    const iconZeffyLogo = theme.zeffyLogoVariant === "dark" ? icons_1.EMAIL_ICON_DATA_URI.zeffyDark : icons_1.EMAIL_ICON_DATA_URI.zeffyLight;
    const emailLocale = (0, locales_1.resolveUntranslatedSpanishEmailLocale)(locale.toUpperCase()).toLowerCase();
    const labels = (0, email_templates_1.getEmailLabels)(emailLocale);
    const resolvedOrgName = orgName || "Bright Futures Foundation";
    const subjectLabel = isInMemory ? labels.tributeInMemorySubject : labels.tributeInHonourSubject;
    return {
        labels,
        theme,
        iconZeffyLogo,
        lang: emailLocale,
        subject: subjectLabel.replace("{orgName}", resolvedOrgName).replace("{inHonourName}", inHonourName),
        orgName: resolvedOrgName,
        isInMemory,
        firstName,
        lastName,
        inHonourName,
        message,
    };
};
exports.buildTributeMockData = buildTributeMockData;
